// extracted by mini-css-extract-plugin
export default {"button":"continue-subscription_button__boibN"};